import { Box, Button, Tabs, getColor, Icons, Typography, useToast } from "fds";
import "./index.scss";
import utilsCommon from "../../shared/utils/common";
import GuideIcon from "../../components/Icons/GuideIcon";
import OsIcon from "../../components/Icons/OSIcon";
import config from "../../shared/config/config";
import { nanoid } from "@reduxjs/toolkit";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
import { useTranslation } from "react-i18next";

const DownloadClientPage = ({
  changeLoading,
}: {
  changeLoading: (status: boolean) => void;
}) => {
  const GATEWAY_URL = config.servers.gateway.url;
  const toast = useToast();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);

  /** 윈도우 다운로드 버튼 클릭시 */
  const downloadService = (osName: "32" | "64"): void => {
    const URL = `${GATEWAY_URL}/papi/public/client/${osName}`;
    changeLoading(true);
    axios
      .get(URL)
      .then((answer) => {
        const newDiv = document.createElement("a");
        newDiv.href = URL;
        newDiv.click();
        changeLoading(false);
      })
      .catch((err) => {
        changeLoading(false);
        toast.toastMsg(nanoid(), err.message ?? "ERROR", "error");
      });
  };
  const openGuide = (osName: string) => {
    const SERVICE_TYPE = window.eco.serviceType;
    switch (osName) {
      case "windows":
        if (
          SERVICE_TYPE &&
          (SERVICE_TYPE === "CLOUD" || SERVICE_TYPE === "cloud")
        ) {
          window.open(t("login.download.windowDownload"));
        } else {
          window.open(GATEWAY_URL + t("login.download.windowOnpremise"));
        }
        break;
      case "mac":
        if (
          SERVICE_TYPE &&
          (SERVICE_TYPE === "CLOUD" || SERVICE_TYPE === "cloud")
        ) {
          window.open(t("login.download.macDownload"));
        } else {
          window.open(GATEWAY_URL + t("login.download.macOnpremise"));
        }
        break;
      case "manager":
        if (
          SERVICE_TYPE &&
          (SERVICE_TYPE === "CLOUD" || SERVICE_TYPE === "cloud")
        ) {
          window.open(t("login.download.adminGuide"));
        } else {
          window.open(GATEWAY_URL + t("login.download.adminOnpremise"));
        }
        break;
      case "video":
        window.open(t("login.download.videoLink"));
        break;
    }
  };
  return window.eco.isCustomService ? (
    <div />
  ) : (
    <Box classes="downloadClient" direction="column">
      <img
        src={utilsCommon.renderWrapsodyECOLogo()}
        width={200}
        alt="logo"
        className="cursor pointer"
        onClick={() =>
          loginDto
            ? navigate(`${process.env.PUBLIC_URL}/home`)
            : navigate(`${process.env.PUBLIC_URL}/login`)
        }
      />
      <Typography classes="mg mt-32" type="h1">
        {t("login.login.newECO")}
      </Typography>
      <Typography
        type="body1_rg"
        exactColor={getColor("COLOR_TEXT_SECONDARY")}
        classes="mg mt-20"
        wordBreak="keep-all"
        textAlign="center"
      >
        {t("login.download.desc")}
      </Typography>
      <Box classes="mg mt-60 downloadClient-guides">
        <Box classes="windows" onClick={() => openGuide("windows")}>
          <GuideIcon type="windows" />
          <Typography classes="mg mt-16" type="h3">
            {t("login.download.window")}
          </Typography>
        </Box>
        {window.eco.isUseMac && (
          <Box classes="mac" onClick={() => openGuide("mac")}>
            <GuideIcon type="mac" />
            <Typography classes="mg mt-16" type="h3">
              {t("login.download.mac")}
            </Typography>
          </Box>
        )}
        <Box classes="video" onClick={() => openGuide("video")}>
          <GuideIcon type="video" />
          <Typography classes="mg mt-16" type="h3">
            {t("login.download.video")}
          </Typography>
        </Box>
      </Box>
      <Box classes="downloadClient-downloads" style={{ marginTop: 60 }}>
        <Box>
          <Box>
            <OsIcon type="windows" />
            <Box direction="column" classes="mg ml-16">
              <Typography type="h3">Windows</Typography>
              <Typography
                type="body1_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                32-bit
              </Typography>
            </Box>
          </Box>
          <Button
            label={t("common.download")}
            btnStyle="fill"
            onClick={() => downloadService("32")}
          />
        </Box>
        <Box>
          <Box>
            <OsIcon type="windows" />
            <Box direction="column" classes="mg ml-16">
              <Typography type="h3">Windows</Typography>
              <Typography
                type="body1_rg"
                exactColor={getColor("COLOR_TEXT_SECONDARY")}
              >
                64-bit
              </Typography>
            </Box>
          </Box>
          <Button
            label={t("common.download")}
            btnStyle="fill"
            onClick={() => downloadService("64")}
          />
        </Box>
      </Box>
      {window.eco.isUseMobile && (
        <Box classes="downloadClient-downloads mg mt-20">
          <Box>
            <Box alignItems="center">
              <OsIcon type="andriod" />
              <Typography type="h3" classes="mg ml-16">
                Android
              </Typography>
            </Box>
            <Box alignItems="center">
              <img
                src={require("../../shared/images/common/android.png")}
                alt="qr_adnroid"
                width={60}
                height={60}
              />
              <a
                style={{ textDecoration: "none" }}
                href="https://play.google.com/store/apps/details?id=com.fasoo.m.wrapsodyEco"
              >
                <Button
                  label={t("common.download")}
                  btnStyle="fill"
                  classes="mg ml-8"
                />
              </a>
            </Box>
          </Box>
          <Box>
            <Box alignItems="center">
              <OsIcon type="andriod" />
              <Typography type="h3" classes="mg ml-16">
                iOS
              </Typography>
            </Box>
            <Box alignItems="center">
              <img
                src={require("../../shared/images/common/ios.png")}
                alt="qr_adnroid"
                width={60}
                height={60}
              />
              <a
                style={{ textDecoration: "none" }}
                href="https://itunes.apple.com/kr/app/wrapsody-eco/id1443705694?mt=8"
              >
                <Button
                  label={t("common.download")}
                  btnStyle="fill"
                  classes="mg ml-8"
                />
              </a>
            </Box>
          </Box>
        </Box>
      )}
      <Typography
        type="body2_rg"
        exactColor={getColor("COLOR_TEXT_SECONDARY")}
        classes="mg mt-auto"
      >
        © Fasoo
      </Typography>
    </Box>
  );
};

export default DownloadClientPage;
